var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.aliveSlots),function(slot){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCurrentSlot(slot)),expression:"isCurrentSlot(slot)"}],key:slot,staticClass:"gl-h-full gl-w-full"},[_vm._t(slot)],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }